export default function InternalInfoIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <g opacity="0.5" clipPath="url(#clip0_1152_45780)">
                <path
                    d="M8.34245 14.7259C12.0243 14.7259 15.0091 11.7411 15.0091 8.05924C15.0091 4.37735 12.0243 1.39258 8.34245 1.39258C4.66055 1.39258 1.67578 4.37735 1.67578 8.05924C1.67578 11.7411 4.66055 14.7259 8.34245 14.7259Z"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.34375 10.7253V8.05859" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.34375 5.39258H8.35042" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1152_45780">
                    <rect width="16" height="16" fill="white" transform="translate(0.34375 0.0585938)" />
                </clipPath>
            </defs>
        </svg>
    )
}
